@if (isDesktop) {
  <div class="side-panel-backdrop" (click)="onBackdropClick($event)" aria-hidden="true"></div>
  <div [class]="'side-panel-desktop ' + sidePanel().size" role="dialog" aria-modal="true" [attr.aria-labelledby]="'desktop-side-panel-title-' + sidePanel().id">
    <header class="header">
      <div class="toolbar">
        <div class="content">
          <div class="title-group">
            <h1 class="title" [id]="'desktop-side-panel-title-' + sidePanel().id">{{ sidePanel().title ?? '' }}</h1>
            @if (sidePanel().badge; as badge) {
              <div class="badge">
                @if (badge.icon) {
                  <img class="badge-icon" [src]="'assets/icons/' + badge.icon + '.svg'" [alt]="'Ícono de ' + badge.label">
                }
                <span class="badge-label">{{ badge.label }}</span>
              </div>
            }
          </div>
          <img class="icon" src="assets/icons/cross.svg" alt="Cerrar" role="button" tabindex="0" (click)="close()" (keydown.enter)="close()" (keydown.space)="close()" />
        </div>
      </div>
    </header>
    <div class="main-content-wrapper">
      <div class="main-content">
        <ng-container *ngComponentOutlet="sidePanel().component; inputs: sidePanel().inputs"></ng-container>
      </div>
    </div>
  </div>
}
<ion-modal [class]="'side-panel-mobile ' + sidePanel().size" [breakpoints]="[0, 1]" [initialBreakpoint]="1" [isOpen]="!isDesktop" (willDismiss)="onMobileWillDismiss()">
  <ng-template>
    <ion-header class="header">
      <ion-toolbar class="toolbar">
        <div class="content">
          <div class="title-group">
            <h1 class="title">{{ sidePanel().title ?? '' }}</h1>
            @if (sidePanel().badge; as badge) {
              <div class="badge">
                @if (badge.icon) {
                  <img class="badge-icon" [src]="'assets/icons/' + badge.icon + '.svg'" [alt]="'Ícono de ' + badge.label">
                }
                <span class="badge-label">{{ badge.label }}</span>
              </div>
            }
          </div>
          <img class="icon" src="assets/icons/cross.svg" alt="Cerrar" (click)="close()" (keyup.enter)="close()" tabindex="0" />
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="main-content">
        <ng-container *ngComponentOutlet="sidePanel().component; inputs: sidePanel().inputs"></ng-container>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
